import { useState, useEffect } from "react";
import { dbGet } from "../lib/db";

const SK  = "reconectados_journal";
const MK  = "reconectados_morning";
const MOK = "reconectados_moments";

export default function WeeklySummary() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    async function compute() {
      const [eveningList, morningMap, allMoments] = await Promise.all([
        dbGet(SK, []),
        dbGet(MK, {}),
        dbGet(MOK, []),
      ]);

      const today = new Date();
      const days = [];
      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        days.push(d.toISOString().slice(0, 10));
      }

      let registeredDays = 0;
      let totalRisk = 0;
      let riskCount = 0;
      const triggerCounts = {};

      days.forEach(day => {
        const hasEvening = eveningList.some(e => e.date?.slice(0, 10) === day);
        const hasMorning = !!morningMap[day];
        if (hasEvening || hasMorning) registeredDays++;

        const evening = eveningList.find(e => e.date?.slice(0, 10) === day);
        if (evening) {
          totalRisk += evening.riskLevel ?? 0;
          riskCount++;
          evening.triggers?.forEach(t => {
            triggerCounts[t] = (triggerCounts[t] || 0) + 1;
          });
        }
      });

      const avgRisk   = riskCount > 0 ? (totalRisk / riskCount).toFixed(1) : null;
      const topEntry  = Object.entries(triggerCounts).sort((a, b) => b[1] - a[1])[0];
      const topTrigger = topEntry ? { name: topEntry[0], count: topEntry[1] } : null;

      setStats({ registeredDays, avgRisk, topTrigger });
    }
    compute();
  }, []);

  if (!stats || (stats.registeredDays === 0 && !stats.avgRisk)) return null;

  return (
    <div className="bg-[#EEF4F1] rounded-2xl p-4 mb-4 border border-[#C8DDD5] animate-fade-in">
      <p className="text-xs font-semibold text-[#2C4238] uppercase tracking-wide mb-3">
        Resumen últimos 7 días
      </p>
      <div className="grid grid-cols-2 gap-2">
        <div className="bg-white rounded-xl px-3 py-2.5">
          <p className="text-xs text-[#2C4238] mb-0.5">Días registrados</p>
          <p className="text-xl font-bold text-[#1E2F23]">
            {stats.registeredDays}
            <span className="text-xs font-normal text-[#4A6E5C]">/7</span>
          </p>
        </div>
        <div className="bg-white rounded-xl px-3 py-2.5">
          <p className="text-xs text-[#2C4238] mb-0.5">Riesgo medio</p>
          <p className="text-xl font-bold text-[#1E2F23]">
            {stats.avgRisk ?? "—"}
            <span className="text-xs font-normal text-[#4A6E5C]">/10</span>
          </p>
        </div>
        {stats.topTrigger && (
          <div className="bg-white rounded-xl px-3 py-2.5 col-span-2">
            <p className="text-xs text-[#2C4238] mb-0.5">Trigger más frecuente</p>
            <p className="text-sm font-semibold text-[#1E2F23]">
              {stats.topTrigger.name}
              <span className="text-xs font-normal text-[#4A6E5C] ml-1">
                · {stats.topTrigger.count} {stats.topTrigger.count === 1 ? "vez" : "veces"}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
